import styled from 'styled-components';
import StyledCtaButton from '../CTA/styles';

const StyledSubmitButton = styled(StyledCtaButton)``;

export default StyledSubmitButton;
